import level1Activities from "./level1Activities";
import level1Catalog from "./level1Catalog";
import { costCategories, costItemNotes, costItems } from "./level1Costs";

export default {
  // Intro screen
  introTitle: "プロジェクトについて教えてください",
  introSubtitle: "フォームに入力してカーボンプロジェクトを設定します",
  startApplication: "申請を開始",
  introSummary: "概要",
  introSummaryDesc: "プロジェクトの基本情報",
  introData: "データ",
  introDataDesc: "境界ファイル、PDD、現地データ",
  introCredits: "クレジット",
  introCreditsDesc: "カーボンクレジット予測",
  introCosts: "コスト",
  introCostsDesc: "プロジェクト期間全体のコスト",

  // Navigation
  learnMore: "詳細を見る",
  previous: "戻る",
  continue: "続ける",
  submit: "送信",
  backToDrafts: "下書きに戻る",
  submissionFailed:
    "プロジェクトを送信できませんでした。下書きは保存されています。もう一度試すか、問題が続く場合はサポートへお問い合わせください。",
  auditorNotApproved:
    "選択した監査人は、現在のオンチェーン信頼レジストリで承認されていません。プロジェクトを送信する前に、管理者が管理画面で監査人を承認する必要があります。",
  submissionSupportReference: "サポート参照: {reference}",
  contactSupport: "サポートに連絡",
  stagePricingFailed:
    "ステージ価格を計算できませんでした。もう一度お試しください。",
  editCosts: "コストを編集",

  // Step 1: Summary
  projectName: "プロジェクト名",
  projectNamePlaceholder: "プロジェクト名",
  projectDescription: "プロジェクト説明",
  projectDescriptionPlaceholder:
    "対象地域、目的などの概要を入力してください。",
  projectType: "プロジェクト種別",

  // Step 2: Data
  projectBoundary: "プロジェクト境界",
  projectBoundaryDesc: "プロジェクト区域の地理的境界",
  uploadKmlFile: "KMLファイルをアップロード",
  uploadKmlKmz: "KML/KMZをアップロード",
  uploading: "アップロード中...",
  uploadError: "アップロードに失敗しました。もう一度お試しください。",
  calculatingCarbonEstimate: "炭素推定値を計算中…",
  computingCredits: "カーボンクレジットを計算中...",
  fieldData: "現地データ",
  fieldDataDesc: "調査区の測定値と現地検証データ",
  existingDataset: "既存データセット",
  uploadDataset: "データセットをアップロード",
  noDataset: "データセットなし",
  useRemoteSensing: "リモートセンシングを使用",
  certification: "認証",
  methodology: "方法論",
  pddInfo:
    "選択した方法論に応じて、プロジェクト設計書（PDD）の作成またはアップロードが必要です。",
  landOwnershipStatus: "土地所有状況",
  landOwnershipPlaceholder: "権利区分を選択",
  landOwnershipHelper:
    "ブラジルの土地保有慣行（CCIR/登記、占有、入植地、先住民土地、キロンボーラ、保全区域、コンセッション）に基づく項目です。",
  landStatusOptions: {
    private_title: "私有",
    possession: "占有（非公式）",
    agrarian_settlement: "農地改革入植地",
    indigenous_territory: "先住民土地",
    quilombola: "キロンボーラ共同体",
    conservation_unit: "保全区域（RPPN、APA など）",
    forest_concession: "森林コンセッション",
    other: "その他（記入）",
  },
  // Step 3: Credits
  estimationMethod: "推定方法",
  fieldPlotData: "現地調査区データ",
  biomassCalculator: "バイオマス計算機",
  plotBasedEstimation: "調査区ベースの推定",
  remoteSensingEstimation: "リモートセンシング推定",
  plotsAnalyzed: "{area}ヘクタール内の{count}調査区を分析",
  projected: "予測",
  lowEstimate: "低位推定",
  midEstimate: "中位推定",
  highEstimate: "高位推定",
  years: "{n}年",
  creditsNotReady: "クレジット推定を表示するには、データステップに戻って境界ファイルとデータセットをアップロードしてください。",
  creditsComputing: "クレジット推定を計算しています。続行する前にお待ちください。",
  creditsComputeFailed:
    "クレジット推定を計算できませんでした。サーバーから有効な応答がありませんでした。再試行し、続く場合はサポートに連絡してください。",
  creditsComputeFailedWithDetail: "クレジット推定を計算できませんでした: {error}",
  yearsProjected: "{count}年分を予測",

  // Step 4: Costs
  costSetting: "コスト設定",
  costSettingDesc: "コスト計算の基本設定",
  currency: "通貨",
  startYear: "開始年",
  durationYears: "期間（年）",
  durationYearsValue: "{years}年",
  timelineMirror: "（スケジュールタブで設定）",
  perYearBreakdownTitle: "年別コスト内訳",
  perYearBreakdownDesc:
    "提案のみ — スケジュールから導出。上の編集可能な合計が引き続き真のソースです。",
  year: "年",
  totalLabel: "合計",
  cost: {
    validation: "検証",
    monitoring: "モニタリング",
    verification: "確認",
    issuance: "発行",
    community: "コミュニティ",
  },
  otherCertifierFeesTitle: "その他の認証機関手数料",
  otherCertifierFeesDesc:
    "プロジェクトのライフサイクルとは別に発生する取引手数料・方法論手数料。表示のみ。プロジェクト総額には加算されません。",
  requiresQuoteTitle: "見積もり必要",
  landownerCompensation: {
    title: "土地所有者補償",
    desc: "クレジットが販売可能になる前の私有地プロジェクト向け、投資家負担の任意補償です。",
    include: "補償コストを含める",
    total: "合計",
    monthly: "月額",
    monthlyPerFamily: "1世帯あたり月額",
    estimatedFamilies: "受益世帯数の見積もり",
    estimatedFamiliesInvalid: "1以上の整数を入力してください。",
    months: "月数",
    stageCostIncluded: "対象となるプロジェクトステージのコストに配分されます。",
    allocation: "配分",
    payoutStart: "支払い開始",
    startStage: "開始するステージ後",
    startDate: "開始日",
    maxMonths: "最大月数",
    removedReason: "削除理由",
    removedReasonPlaceholder: "このコストを削除する理由",
    payoutProjectStart: "プロジェクト開始",
    payoutAfterStage: "選択したステージの資金確保後",
    payoutExplicitDate: "指定日",
    allocationUniform: "ステージに均等配分",
    allocationUpfront: "前払いエスクロー",
    basis: "算定根拠",
    winningComponent: "採用された構成要素",
    confidence: "信頼度",
    estimateOnly: "見積もりのみ",
    productionBlocked: "本番利用は未対応",
  },
  communityBenefitPayout: {
    title: "コミュニティ便益支払い",
    desc: "対象となるREDD+・保全プロジェクト向けの、投資家負担の任意便益支払いです。",
    include: "コミュニティ便益支払いを含める",
    total: "合計",
    monthly: "月額",
    monthlyPerFamily: "世帯あたり月額",
    monthlyPayoutPerFamily: "世帯あたり月額支払い（BRL）",
    monthlyPayoutPerFamilyInvalid: "0より大きい月額を入力してください。",
    amountInvalid: "0より大きい金額を入力してください。",
    estimatedFamilies: "受益世帯数の見積もり",
    estimatedFamiliesInvalid: "正の整数で世帯数を入力してください。",
    months: "月数",
    allocation: "配分",
    payoutStart: "支払い開始",
    startStage: "開始するステージ後",
    startDate: "開始日",
    maxMonths: "最大月数",
    removedReason: "削除理由",
    removedReasonPlaceholder: "この支払いを削除する理由",
    payoutProjectStart: "プロジェクト開始",
    payoutAfterStage: "選択したステージの資金確保後",
    payoutExplicitDate: "指定日",
    allocationUniform: "ステージに均等配分",
    allocationUpfront: "前払いエスクロー",
    stageCostIncluded: "対象となるプロジェクトステージの費用に配分されます。",
    basis: "算定根拠",
    winningComponent: "採用された構成要素",
    confidence: "信頼度",
    estimateOnly: "見積もりのみ",
    productionBlocked: "本番利用は未対応",
    notCalculable: "現在の出典、クレジット、受益者情報では算定できません。",
    notCalculableAction: "算定するには、便益配分契約と受益世帯数の見積もりを入力してください。",
    missingInputs: "必要な入力",
    predictionLadder: "計算経路",
    estimateTag: "見積もり",
    estimateRung: "計算段階",
    revenueBasis: "収益基準",
    sources: "出典",
    beneficiaries: "受益者",
    perHousehold: "世帯あたり",
    perHouseholdMonthly: "世帯・月あたり",
    ladder: {
      sourced_minimum: "署名済み契約または出典付きの法的・基準最低額。",
      pct_of_forecast_revenue: "期間全体の予測クレジット、選択価格、出典付き便益配分率。",
      opportunity_cost_floor: "対象コミュニティ面積とコミュニティに帰属する機会費用下限。",
      unavailable: "利用可能な予測経路がない場合は署名済み契約が必要です。",
    },
    yes: "はい",
    audit: {
      platform_policy_proxy: "プラットフォーム方針プロキシ",
      pct_of_forecast_revenue: "予測炭素収益の割合",
      proxy_per_hectare: "ヘクタール単位のプロキシ方針",
      proxy_per_household: "世帯単位のプロキシ方針",
      unavailable: "利用不可",
      platform_policy_proxy_estimate_only:
        "これはプラットフォーム方針プロキシによる見積もりのみです。",
      area_overlap_unchecked:
        "エリア重複レビューが未確認のため、本番利用はブロックされています。",
      benefit_share_reference_unverified:
        "一致した便益配分参照は、この基準では未検証です。",
      benefit_share_reference_requires_approval:
        "便益配分参照には管理者または法務レビューが必要です。",
      community_benefit_proxy_policy_missing:
        "有効なコミュニティ便益プロキシ方針がありません。",
      community_benefit_proxy_policy_has_no_computable_rate:
        "有効なプロキシ方針に、このドラフトで算定可能な料率がありません。",
      community_benefit_proxy_policy_missing_provenance:
        "プロキシ方針に承認または出典の来歴がありません。",
      community_benefit_source_provenance_missing:
        "出典付き便益額に十分な出典来歴がありません。",
      community_benefit_fixture_value_rejected:
        "テストデータのような便益額が拒否されました。",
      community_benefit_estimate_unavailable:
        "現在の入力ではコミュニティ便益見積もりを算定できません。",
      forecast_revenue_missing:
        "予測クレジットまたは選択価格が不足しています。",
      community_benefit_forecast_revenue_missing:
        "予測クレジットまたは選択価格が不足しています。",
      community_benefit_forecast_credit_estimate_refused:
        "現在の炭素クレジット見積もりは拒否され、便益予測には使用できません。",
      community_benefit_forecast_credit_estimate_missing:
        "現在の炭素クレジット見積もりが必要です。",
      forecast_credit_estimate_refused:
        "現在の炭素クレジット見積もりは拒否されました。",
      benefit_compensation_overlap_review:
        "土地所有者補償とコミュニティ便益の重複は、配分前のレビューが必要です。",
      signed_benefit_sharing_agreement_required:
        "この文脈では署名済み便益配分契約が必要です。",
      outside_commercial_driver_requires_agreement:
        "外部商業ドライバーのプロジェクトには署名済み便益配分契約が必要です。",
      benefit_share_revenue_basis_requires_review:
        "一致した収益基準は、使用前に法務または管理者レビューが必要です。",
      estimate_only_prediction:
        "これは投資段階の見積もりのみで、本番利用はできません。",
      no_beneficiary_identified:
        "受益者がまだ特定されていません。",
      beneficiary_kyc_not_verified_for_direct_payout:
        "直接支払い用の受益者KYCが確認されていません。",
      safeguards_failed_or_missing:
        "セーフガード証拠が不足しているか未承認です。",
      proxy_fixed_minimum_floor_applied:
        "プラットフォーム固定最小額が算定見積もりを引き上げました。",
      low: "低",
      medium: "中",
      high: "高",
      blocked: "ブロック",
    },
  },
  scaleClassification: "規模分類（FR.CER.001）",
  scaleClassificationDesc: "クレジットから自動計算",
  estimatedTco2eYear: "推定tCO2e/年",
  projectScale: "プロジェクト規模",
  smallScale: "小規模（16,000 tCO2e/年未満）",
  largeScale: "大規模（16,000 tCO2e/年以上）",
  loadingCostEstimates: "コスト見積もりを読み込み中...",
  validationVvb: "妥当性確認 / VVB体制",
  vvbBasedOn: "DC.GOV.002およびDC.GOV.003に基づく",
  vvbSmallScaleTitle: "小規模 — Teroが監査人を手配",
  vvbSmallScaleCost: "妥当性確認コスト: {cost}（固定）",
  teroSmallScaleFeeText:
    "この見積もりではR$に換算（元の手数料はUSD 1,000/プロジェクト、受入基準はUSD 1,000 + USD 200/農村物件）",
  vvbSmallScaleDesc:
    "小規模プロジェクトでは、利益相反ルールへの適合を確保するため、Tero CarbonがVVBを直接契約します。妥当性確認コストはTeroの標準料金で固定されます。",
  oneTime: "一回限り",
  recurring: "定期",
  addItem: "項目を追加",
  itemName: "項目名",
  amount: "金額",
  units: {
    credit: "クレジット",
    year: "年",
  },
  costSummary: "コスト概要",
  year1Total: "1年目合計",
  avgAnnual: "年平均",
  lifetimeTotal: "期間合計",
  costPerCredit: "コスト / クレジット",
  costBreakdown: "コスト内訳",

  // Step 5: Price Quote
  priceQuoteTitle: "価格見積もり",
  priceQuoteDesc: "適用する販売可能な価格戦略を選択してください。診断用の下限は別に表示されます。",
  recompute: "再計算",
  loadingQuote: "価格見積もりを計算中...",
  priceQuoteFailed: "価格見積もりの計算に失敗しました。続行する前に再度ログインするか、再計算してください。",
  loadingStagePricing: "ステージ別価格を計算中...",
  indicativePrice: "参考価格",
  bandFloor: "下限",
  bandSuggested: "推奨",
  bandStretch: "上振れ",
  bandCeiling: "上限",
  priceOptionRecommended: "推奨される契約実行可能価格",
  priceOptionFeasible: "契約実行可能価格",
  priceOptionTiers: {
    floor: "下限",
    suggested: "推奨",
    stretch: "上振れ",
    ceiling: "上限",
  },
  roiOnCashCosts: "現金コストに対するリターン",
  breakEvenFloorLabel: "損益分岐下限",
  breakEvenDiagnostic:
    "{price} は機会費用を含む経済的な損益分岐点です。推奨価格はこの下限の {margin} です。販売価格ではありません。",
  singleFeasiblePriceAlgorithm:
    "契約上実行可能な価格を算出した価格アルゴリズムは1つだけです。他の結果は比較用に下記へ表示します。",
  algorithmFeasibleDiagnostic:
    "{price} は、このアルゴリズムによる契約上実行可能な結果です。続行するには、上の検証済み価格帯オプションを選択してください。",
  algorithmBelowFeasibleFloor:
    "このアルゴリズムの上限は {maximum} で、ステージ資金と投資家配分上限に必要な最低価格 {minimum} を下回るため選択できません。",
  priceStrategies: {
    supply_curve_oc: "供給曲線 + 機会費用",
    lcor: "修復の均等化コスト",
    lcos: "炭素隔離の均等化コスト",
    macc_breakeven: "MACC 損益分岐",
    label_multiplier: "ラベル倍率",
    leaf_art_floor: "LEAF/ART フロア",
    frontier_pathway_comp: "Frontier 経路比較",
    sovcm_median: "Ecosystem Marketplace 中央値",
    forward_shadow_price: "将来シャドウ価格",
  },
  priceStrategyNotes: {
    supply_curve_oc: "{projectClass} の供給曲線フロア",
    leaf_art_floor: "LEAF/ART 公表の管轄フロア",
    sovcm_median: "SOVCM 2025 カテゴリ中央値（需要側）",
    forward_shadow_price: "REMIND-MAgPIE、2010年米ドル、先進国",
    verra_nature_qha: "Verra Nature Framework Qha（tCO2eではない別単位）",
    frontier_pathway_comp: "{pathway} の Frontier 経路平均",
    lcor: "LCOR: {biome} における {technique}",
    peatland_lcor: "泥炭地の排出回避 LCOR [{variant}]",
    lcos: "LCOS {subclass} [{variant}]",
    macc_breakeven: "MACC {projectClass} [{subType}]",
    label_multiplier: "tCO2e ベースへのラベル倍率（+{premium}）",
  },
  priceStrategyDiagnostics: {
    supply_curve_oc:
      "{price} は、保存されたプロジェクト費用と代替土地利用の機会費用に基づく供給曲線の結果です。このドラフトでは実行可能な販売価格ではありません。",
    lcor:
      "{price} は修復の均等化コストの結果です。このドラフトでは実行可能な販売価格ではありません。",
    lcos:
      "{price} は炭素隔離の均等化コストの結果です。このドラフトでは実行可能な販売価格ではありません。",
    macc_breakeven:
      "{price} は限界削減費用の結果です。このドラフトでは実行可能な販売価格ではありません。",
    default:
      "{price} はこのアルゴリズムの算定結果です。このドラフトでは実行可能な販売価格ではありません。",
  },
  priceStrategyRoleLabels: {
    break_even_floor: "損益分岐フロア",
    binding_break_even_floor: "拘束フロア",
    market_anchored_price: "販売可能価格",
    market_reference_below_cost_floor: "コストフロア未満",
    reference_price: "参考のみ",
    sellable_price: "販売可能価格",
    contract_infeasible_price: "選択不可",
    algorithm_low_price: "実行可能なアルゴリズム価格",
    algorithm_mid_price: "実行可能なアルゴリズム価格",
    algorithm_high_price: "実行可能なアルゴリズム価格",
  },
  priceProjectClasses: {
    aud_redd_plus: "森林減少回避 / REDD+",
    apd: "計画的森林減少の回避",
    acogs: "生態系転換の回避",
    ifm: "改良森林管理",
    arr: "ARR 修復",
    blue_carbon: "ブルーカーボン",
    peatland: "泥炭地",
    grasslands: "草地",
    smallholder_agroforestry: "小規模農家アグロフォレストリー",
    native_veg_brazil: "ブラジル在来植生の修復",
    alm_soc: "農地管理 / 土壌炭素",
    urban_forestry: "都市林",
    biodiversity_wrapper: "生物多様性ラッパー",
    engineered_removal: "工学的炭素除去",
    methane_waste: "廃棄物由来メタン",
    community_development: "コミュニティ開発",
    energy_industry: "エネルギー・産業",
  },

  // Stage pricing block
  stagePricingTitle: "ステージ別価格",
  stagePricingDesc: "クレジット期間の各年について、ステージ別の価格とROIを表示します。年をクリックすると展開できます。",
  stagePricingNoData: "ステージ別価格データはまだありません。価格ステップを完了して続行すると、ここに結果が表示されます。",
  stagePricingNoStageDetail: "ステージ詳細はありません。",
  yearLabel: "{n}年目",
  showMoreYears: "+ さらに{count}年を表示 | + さらに{count}年を表示",
  showFewerYears: "表示年数を減らす",
  avgRoi: "ROI",

  // Step 6: Review
  reviewTitle: "確認",
  missingPdd: "PDDがありません",
  missingPddDesc:
    "プロジェクトを送信する前にPDDが必要です。",
  createPdd: "PDDを作成",
  upload: "アップロード",
  uploadPdd: "添付",
  replacePdd: "PDDを差し替え",
  pddUploaded: "PDDを添付しました",
  pddUploadedDesc: "PDDファイルが添付されています。",
  location: "所在地",
  projectArea: "プロジェクト面積",
  projectAreaValue: "{area} ha",
  totalCredits: "総クレジット",
  peakYear: "ピーク年（{year}）",
  estimationMethodLabel: "推定方法",
  lifetimeTotalCosts: "期間総コスト",
  annualAverage: "年平均",
  costPerCreditLabel: "クレジットあたりコスト",

  // Revenue block
  lifetimeTotalRevenue: "期間総収益",
  year1Revenue: "1年目収益",
  avgRevenue: "平均収益",

  // Profit block
  lifetimeProfit: "期間利益",
  year1Profit: "初回発行年の利益",
  annualAverageRoi: "年平均ROI",
  profitPerCredit: "クレジットあたり利益",

  mapNotAvailable: "地図プレビューは利用できません。KML/KMZファイルをアップロードするとプロジェクト区域を表示できます。",

  // Step 3: Activities
  activitiesTitle: "活動を選択",
  activitiesDesc: "プロジェクトに該当する活動を選択してください",
  addOwnEntry: "独自の項目を追加",
  customActivity: "カスタム活動",
  activityNamePlaceholder: "活動名",
  activityDescPlaceholder: "活動説明",
  addActivity: "追加",
  cancel: "キャンセル",
  activities: level1Activities,
  costCategories,
  costItems,
  costItemNotes,
  catalog: level1Catalog,
  validation: {
    summary: "カーボンプロジェクトの概要を入力してください: {fields}。",
    data: "カーボンプロジェクトのデータを入力してください: {fields}。",
    costs: "カーボンプロジェクトのコストを入力してください: {fields}。",
    authenticationRequired: "認証が必要です。開発者ウォレットを再接続してください。",
    fields: {
      projectName: "プロジェクト名",
      projectDescription: "プロジェクト説明",
      projectType: "プロジェクト種別",
      certifier: "認証機関",
      methodology: "方法論",
      fieldDataOption: "現地データの選択（調査区またはリモートセンシング）",
      landOwnership: "土地所有状況",
      projectBoundaryMap: "プロジェクト境界地図",
      projectArea: "プロジェクト面積",
      currency: "通貨",
    },
  },

  // Step Chooser
  chooserTitle: "プロジェクトの種類を選択",
  chooserSubtitle: "発行済みクレジットを掲載するか、資金調達用プロジェクトを作成します",
  chooserListCreditsTitle: "発行済みカーボンクレジット",
  chooserListCreditsBtn: "クレジットを掲載",
  chooserNewProjectTitle: "資金調達用プロジェクトを作成",
  chooserNewProjectBtn: "プロジェクトを開始",

  // List Credits form
  lcProjectLink: "プロジェクトリンク",
  lcPddUpload: "プロジェクト設計書をアップロード",
  lcLocation: "所在地",
  lcLocationDesc: "プロジェクト所在地を入力するか、KMLをアップロードして自動検出します",
  lcUploadKml: "KML/KMZをアップロード",
  lcBiome: "バイオーム",
  lcState: "州",
  lcBoundary: "プロジェクト境界（KML/KMZ）",
  lcPhotos: "写真",
  lcPhotosDesc: "プロジェクトの写真をアップロードしてください",
  lcPhotosUploadTitle: "PNGまたはJPGをアップロード",
  lcPhotosSubLabel: "PNGまたはJPGのみ",
  lcYearlyCreditSold: "年間販売クレジット",
  lcYearlyCreditSoldDesc: "年ごとの販売クレジットを記録します",
  lcPriceQuoteDesc: "発行済みクレジットの掲載価格の推奨を取得し、送信前に編集できます。",
  lcGetPriceRecommendation: "価格推奨を取得",
  lcPriceQuoteError: "価格推奨に失敗しました。手動で掲載価格を入力することもできます。",
  listingPrice: "掲載価格",
  lcListingPricePlaceholder: "12.50",

  // Success screen
  formSubmitted: "フォームを送信しました",
  successMessage:
    "送信ありがとうございます。できるだけ早くご連絡します。",
  seeHomepage: "ホームページを見る",

  // Tab labels
  tabs: {
    summary: "概要",
    data: "データ",
    activities: "活動",
    timeline: "スケジュール",
    credits: "クレジット",
    costs: "コスト",
    price: "価格",
    review: "レビュー",
  },

  // Step: スケジュールとクレジット発行
  timeline: {
    scheduleBasicsTitle: "プロジェクトのスケジュール",
    scheduleBasicsDesc:
      "プロジェクトの基準カレンダーを設定します。これら 4 つの値が、検証・モニタリング・クレジット生成・コスト計上のタイミングを決定します。",
    projectStartYear: "プロジェクト開始年",
    projectStartYearHint: "検証・モニタリング・実装が開始されます。",
    creditingStartYear: "最初のクレジット年",
    creditingStartYearHint: "クレジット生成が始まる最初の年です。",
    modelingHorizonYears: "モデル化年数",
    modelingHorizonYearsHint:
      "投資モデル化期間（最大 20 年）。",

    verificationScheduleTitle: "検証 & 発行スケジュール",
    verificationScheduleDesc:
      "ご利用の方法論に合うプリセットを選択してください。詳細設定で派生値を微調整できます。",
    verificationPreset: "検証 & 発行プリセット",

    advancedAssumptions: "詳細設定",
    advancedAssumptionsHint: "プリセットから推定された値を上書きできます。",
    verificationCycleYears: "検証サイクル（年）",
    firstVerificationYear: "初回検証年",
    issuanceFrequency: "発行頻度",
    firstIssuanceYear: "初回発行年",
    advancedDerivedNote:
      "空欄のままにすると、選択したプリセットから派生した値が使用されます。",

    summaryTitle: "スケジュールプレビュー",
    summaryLine:
      "初回検証 {firstVerification} 年 • サイクル {cycle} 年 • {issuance} • 初回発行 {firstIssuance} 年",

    presets: {
      standard_nature_based: "標準: 5 年ごとに検証・発行",
      faster_cycle: "短サイクル: 3 年ごとに検証・発行",
      annual_issuance: "毎年発行",
      engineered_removal: "エンジニアド除去（毎年）",
      gs_annual_reports_2y_first_verification:
        "Gold Standard: 2 年目までに初回検証、その後最長 5 年ごと",
      car_forest_annual_reporting_full_every_6:
        "CAR 森林: 毎年報告、6 期ごとに完全検証",
      puro_engineered_annual_after_audit:
        "Puro エンジニアド: 毎年監査、各監査後に発行",
      custom: "カスタム（詳細設定を開く）",
    },
    presetDesc: {
      standard_nature_based: "検証サイクル: 5 年 • 発行: 検証後ごと。",
      faster_cycle: "検証サイクル: 3 年 • 発行: 検証後ごと。",
      annual_issuance: "検証サイクル: 1 年 • 発行: 毎年。",
      engineered_removal:
        "検証サイクル: 1 年 • 発行: 毎年。DAC・BECCS・バイオ炭に最適。",
      gs_annual_reports_2y_first_verification:
        "検証サイクル: 2 年 • 発行: 検証後ごと。Gold Standard のサイクルに対応。",
      car_forest_annual_reporting_full_every_6:
        "検証サイクル: 6 年 • 発行: 検証後ごと。CAR Mexico Forest Protocol のサイクルに対応。",
      puro_engineered_annual_after_audit:
        "検証サイクル: 1 年 • 発行: 各監査後。Puro General Rules 4.3 に対応。",
      custom: "下の詳細設定で派生値を編集してください。",
    },

    freq: {
      after_verification: "検証後",
      annual: "毎年",
    },

    errors: {
      invalidShape: "スケジュールセクションが欠落または不正です。",
      invalidPreset: "検証と発行のプリセットが認識されません。",
      projectStartYearRange:
        "プロジェクト開始年は {min} 〜 {max} の範囲で指定してください。",
      creditingStartYearRange:
        "最初のクレジット年は {min} 〜 {max} の範囲で指定してください。",
      modelingHorizonRange:
        "モデル化年数は {min} 〜 {max} の範囲で指定してください。契約価格モデルは最大 {max} 年まで対応します。",
      cycleRange: "検証サイクルは {min} 〜 {max} 年の範囲で指定してください。",
      creditingBeforeStart:
        "最初のクレジット年はプロジェクト開始年以降である必要があります。",
    },
  },
};
